/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-param-reassign */
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { advHas } from '@src/slide/infrastructure/module/independent/assert/get-set';
import { observable, reaction } from 'mobx';
import StyleHandler from '../adapter/style-handler';
import SlideBaseModel from './base-modeles/slide-base-model';
import ConvertEngine from './convert/convertEngine';

import NoteModel from './note-model';
import TimingModel from './timing-model';
//  lodash部分引入
import _get from 'lodash/get';
import _set from 'lodash/set';

import { ESpecialOperationType } from '@src/slide/application/service/selection/selected-with-commit-manager.interface';
import { transaction } from '@src/slide/domain/slide-app';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { SlidePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/page/slide-property-converter';
import GuideModelV3 from '@src/slide/domain/ui-model/element-modeles/guide-model-v3';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { INoteModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import {
    ICommentInfo,
    IGroupId,
    ISlideModel,
    SlideModelSdkTypeV3,
} from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import Fill from '@src/slide/domain/ui-model/element-modeles/property/fill';
import { IFillProperty } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { SlideFooter } from '@src/slide/domain/ui-model/element-modeles/property/slide-footer';
import { IFooterProps, ISlideFooter } from '@src/slide/domain/ui-model/element-modeles/property/slide-footer/slide-footer.interface';
import TransitionProperty from '@src/slide/domain/ui-model/element-modeles/property/transition';
import { ITransitionProperty } from '@src/slide/domain/ui-model/element-modeles/property/transition/interface';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import TaskManager, { TaskPriority } from '@src/slide/infrastructure/module/dependent/taskManager';
import { ITask } from '@src/slide/infrastructure/module/dependent/taskManager/ITask';
import TaskGroup from '@src/slide/infrastructure/module/dependent/taskManager/taskGroup';
import { DataModelChange, DataType, ISlideDataModel, LayoutDataModel, MasterDataModel, SlideDataModel } from '@tencent/slide-sdk-model';
import { ICommentGroup } from '@tencent/slide-sdk-model/src/data/comment-data';
import { ElementsAnalyze } from './elements-analysis';
import { getElementModelConstructorByType } from './factories/element-model-factory';
import BatchUpdateFrame from './property/frame/batch-update';
import type { IBatchUpdateFrameProperty } from './property/frame/batch-update/batch-update.interface';

class SlideModel extends SlideBaseModel implements ISlideModel {
    static convertDataUiToSdk(uiData, sdkData, rawUiData) {
        super.convertDataUiToSdk(uiData, sdkData, rawUiData);

        SlidePropertyConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
    }

    /* eslint-disable complexity */
    static async convertDataSdkToUi(sdkData, uiData, rawSdkData, change?: DataModelChange) {
        // @ts-ignore
        const remove = change?.remove ?? false;
        const dataType = DataType?.[sdkData.type];

        // slideSdk在分页时存在空白页的未完成状态，waitForLoading调用时sdk才是完整状态
        // 不分页的话waitForLoading会立即执行
        if (sdkData.type === DataType.Slide) {
            (sdkData as unknown as SlideDataModel).waitForLoading?.(() => {
                if (uiData.preload) {
                    uiData.preload = false;
                }
            });
        }

        global.log.info('[key process]', `${dataType} - ${sdkData.id} convert start`);
        super.convertDataSdkToUi(sdkData, uiData, rawSdkData);

        const convertPromises: Array<Promise<any>> = [];

        let convertChildren = false;

        if ((!uiData.asyncConvertChildren || uiData.autoConvertChildren) && !remove) {
            convertChildren = true;
            uiData.convertSdkToUiChildrenLogic(rawSdkData, remove);
        }

        SlidePropertyConverter.convertPartialDataFromSdkToUi(sdkData.props, uiData, change);

        // master/layout的参考线
        if ([UIModelType.MASTER, UIModelType.LAYOUT].includes(uiData.type)) {
            if (!uiData.guideModel) {
                uiData.guideModel = new GuideModelV3();
                uiData.guideModel.bindSDK(sdkData);
            }
        }

        // TODO 这里需要动画负责同学重构，ui不应该面向sdk数据编程
        if (sdkData.props.timing) {
            uiData.timing = sdkData.props.timing;
        } else {
            delete uiData.timing;
        }
        // 备注
        SlideModel.createNoteData(uiData, remove);
        const noteData = sdkData.getNoteSlide?.();
        if (noteData) {
            const convertNotePromise = (uiData.noteData as NoteModel).bindSDK(noteData);
            convertPromises.push(convertNotePromise);
        } else {
            // 第一次创建备注，撤销，会删除备注，此时需重置备注节点
            uiData.noteData.unbindSDK();
            uiData.noteData.initData();
        }
        if (convertChildren) {
            convertPromises.push(uiData.convertTimingDataSdkToUi?.());
        }

        if (uiData.asyncConvertChildren) {
            await Promise.all(convertPromises);
        }
        if (uiData.isSlide) {
            global.log.info('[key process]', `${dataType} - ${sdkData.id} convert end`, uiData.children?.length);
        }
    }

    static createNoteData(uiData, remove) {
        if (!uiData.noteData && !remove) { // 删除的时候
            const ui = new NoteModel();
            ui.initData();
            ui.parent = uiData;
            ui.selectionService = uiData.selectionService;
            uiData.noteData = ui;
        }
    }

    static didConvertDataSdkToUi(sdkData, uiData, rawSdkData, optionObject) {
        super.didConvertDataSdkToUi(sdkData, uiData, rawSdkData, optionObject);
    }
    @observable
    public pptEditorState = PPTEditorStateType.EDITABLE;

    // 是否显示子元素
    @observable
    public displayChildrenElement = true;

    // 子元素是否转换完成
    @observable
    public childrenConverted = false;

    @observable
    public slideIndex = null;

    // 需要高亮边框的元素Id
    @observable highlightModelId = null;

    // 动画元素是否转换完成
    @observable animConverted = false;

    // 主队列动画总时间线
    @observable mainSlideTimeline = null;

    // 是否是SDK提供的预加载数据
    @observable preload = true;

    @observable name = '';

    // 是否展示母版元素
    @observable showMasterSp = 1;

    // 幻灯片是否隐藏
    @observable isShowInPlay = true;

    public timingModel?: TimingModel;
    public autoConvertChildren = false;
    public layoutId;
    public timing;
    public noteData: INoteModel;
    public slideFooter: ISlideFooter;
    public commentGroupMap?: Map<string, ICommentGroup>;
    @observable public commentGroupInfoMap?: Map<IGroupId, ICommentInfo[]>;   // 批注具体文本内容以及会员信息等为单独存储，此处做缓存
    private styleHandler: StyleHandler;
    private taskGroup: TaskGroup;
    private fillInstance: IFillProperty;
    private asyncConvertChildrenPromise?: Promise<void>;
    private asyncConvertChildrenResolve;
    private asyncConvertChildrenReaction;
    private bacthUpdateFrameInstance: IBatchUpdateFrameProperty;
    private transitionInstance: ITransitionProperty;

    constructor() {
        super();
        this.props = {
            transition: ['slide'],
            style: {
                fillBackground: null,
                linkColor: null, // 链接主题色
            },
        };
        _set(this, 'props.transition', ['slide']);
        this.styleHandler = new StyleHandler(this);
        this.slideIndex = null;
        this.timing = null; // 动画SDK数据
        this.layoutId = undefined;
        this.slideFooter = new SlideFooter(this);
        this.asyncConvertChildrenPromise = new Promise((resolve) => {
            this.asyncConvertChildrenResolve = resolve;
        });
    }

    public get convertTaskGroup(): ITask {
        if (!this.taskGroup || this.taskGroup.isCanceled || this.taskGroup.isFinished) {
            this.taskGroup = new TaskGroup(
                this.convertChildrenTaskKey(),
                TaskPriority.NORMAL,
            );
            this.taskGroup.concurrent = true;
        }
        return this.taskGroup;
    }

    public get isSlide() {
        return this.type === UIModelType.SLIDE;
    }

    public get childrenPlaceholderInfo() {
        const plInfo: any = {};
        this.children.forEach((child) => {
            if (!child.isPlaceholder) return;
            if (child.isTitleOrCtrTitlePl) plInfo.hasTitle = true;
            if (child.isBodyPl) plInfo.hasBody = true;
            if (child.isDatePl) plInfo.hasDate = true;
            if (child.isFooterPl) plInfo.hasFooter = true;
            if (child.isSlideNumPl) plInfo.hasSlideNum = true;
        });
        return plInfo;
    }

    public getAllChildrenOfPlaceHolder(): IElementBaseModel[] {
        return this.children.filter(child => (child as IElementBaseModel).isPlaceholder);
    }

    public async startConvertChildrenTask(priority): Promise<void> {
        if (this.preload) {
            if (!this.asyncConvertChildrenReaction) {
                this.asyncConvertChildrenReaction = reaction(() => this.preload, () => {
                    this.startConvertChildrenTask(priority);
                    this.asyncConvertChildrenReaction();
                    this.asyncConvertChildrenReaction = null;
                });
            }
            return;
        }
        if (!this.checkContinueConvert(priority)) {
            return this.asyncConvertChildrenPromise;
        }
        await this.asyncConvertChildrenLogic();
        this.asyncConvertChildrenResolve();
    }

    public cancelConvertChildrenTask(): void {
        TaskManager.cancelTaskByKey(this.convertChildrenTaskKey());
    }

    public getBackgroundFill(): IFillProperty {
        if (!this.fillInstance) {
            this.fillInstance = new Fill(this);
        }
        return this.fillInstance;
    }

    public getBatchUpdateFrame = (): IBatchUpdateFrameProperty => {
        if (!this.bacthUpdateFrameInstance) {
            this.bacthUpdateFrameInstance = new BatchUpdateFrame(this.selectionService);
        }
        return this.bacthUpdateFrameInstance;
    };

    /**
     * 抽屉的版式checkbox选中/取消选中回调
     * @param props
     */
    public updatePlaceholderFormat(props: IFooterProps) {
        this.slideFooter.updatePlaceholderFormat(props);
    }

    public toggleShowSlide(show: boolean): void {
        (this.sdkData as SlideModelSdkTypeV3)?.api.updateSlideVisible(show);
    }

    public getMasterId() {
        // @ts-ignore
        return this.sdkData?.context.master.id;
    }

    public getTransitionProperty(): ITransitionProperty {
        if (!this.transitionInstance) {
            this.transitionInstance = new TransitionProperty(this);
        }

        return this.transitionInstance;
    }

    public isSlideSupportAI(): boolean {
        // 目前可以简单通过 descr 是否存在来判断是否是 AI 生成的
        // 后续可以详细解析 descr 来避免脏数据
        return !!this.sdkData?.getOwnedData().cSld.spTree?.nvPr.descr;
    }

    public getAIType(): number | string | undefined {
        return this.getPageAIDescription()?.type;
    }

    getMainSequence() {
        if (!this.timing) {
            return null;
        }
        return this.timing.getMainSequence();
    }

    getAllKindsOfSequence() {
        if (!this.timing) return null;
        return this.timing.getAllKindsOfSequence();
    }

    // 在某页，手动打开动画面板，需要手动调用convert动画数据
    async convertAnimDataSdkToUi() {
        if (this.getRightSideBarManager()?.isAnimationEditorShown && !this.asyncConvertChildren) {
            await this.convertTimingDataSdkToUi();
        }
    }

    async convertTimingDataSdkToUi() {
        const convertPromises: Array<Promise<any>> = [];
        if (!this.timingModel) {
            if (this.sdkData?.timing) {
                const timingModel = new TimingModel();
                timingModel.parent = this;
                timingModel.selectionService = this.selectionService;
                const promise = timingModel.bindSDK(this.sdkData.timing);
                convertPromises.push(promise);
                this.timingModel = timingModel;
            }
        } else if (!this.sdkData?.timing) {
            this.timingModel?.unbindSDK();
            // 清空animList
            this.animList.splice(0);
            delete this.timingModel;
        } else if (this.sdkData.timing !== this.timingModel?.sdkData) { // 删除撤销后， timing对象不一致了，  要重新绑定一下
            const promise = this.timingModel.bindSDK(this.sdkData.timing);
            convertPromises.push(promise);
        }

        await Promise.all(convertPromises);
        this.animConverted = true;
    }

    /**
     * 所有子元素的数目，如果有组合的话计算组合内部的元素
     */
    get elementNumInfo() {
        const elementNumInfo = {
            totel: 0,
            table: 0,
            tableCell: 0,
            shape: 0,
            picture: 0,
            connector: 0,
        };
        for (let i = 0; i < this.children.length; i++) {
            const element = this.children[i];
            this.calculateElementCount(element, elementNumInfo);
        }
        elementNumInfo.totel = elementNumInfo.table + elementNumInfo.connector
            + elementNumInfo.picture + elementNumInfo.shape;
        return elementNumInfo;
    }

    calculateElementCount(element, elementNumInfo) {
        switch (element.type) {
            case UIModelType.TABLE:
                elementNumInfo.table += 1;
                if (advHas(element, 'props.rowHeights')
                    && advHas(element, 'props.colWidths')
                    && element.props.rowHeights.length
                    && element.props.colWidths.length) {
                    elementNumInfo.tableCell += element.props.rowHeights.length * element.props.colWidths.length;
                }
                break;
            case UIModelType.SHAPE:
                elementNumInfo.shape += 1;
                break;
            case UIModelType.IMAGE:
                elementNumInfo.picture += 1;
                break;
            case UIModelType.CONNECTOR:
                elementNumInfo.connector += 1;
                break;
            case UIModelType.GROUP:
                elementNumInfo.shape += ElementsAnalyze
                    .getTypesOfElements(element.children, [UIModelType.SHAPE]).length;
                elementNumInfo.picture += ElementsAnalyze
                    .getTypesOfElements(element.children, [UIModelType.IMAGE]).length;
                elementNumInfo.connector += ElementsAnalyze
                    .getTypesOfElements(element.children, [UIModelType.CONNECTOR]).length;
                break;
        }
    }

    includeInheritChildren() {
        let array: Array<any> = [];
        const presentationModel = this.presentationRef;
        if (presentationModel) {
            const masterChildrenKey = presentationModel.getMasterChildrenMapKey(this.sdkData);
            const layoutChildrenKey = presentationModel.getLayoutChildrenMapKey(this.sdkData);
            if (masterChildrenKey) {
                const masterElements = presentationModel.masterChildrenMap[masterChildrenKey] || [];
                array = array.concat(masterElements
                    .slice(0, masterElements.length));
            }
            if (layoutChildrenKey) {
                const layoutElements = presentationModel.layoutChildrenMap[layoutChildrenKey] || [];
                array = array.concat(layoutElements
                    .slice(0, layoutElements.length));
            }
        }
        array = array.concat(this.children.slice(0, this.children.length));
        return array;
    }

    getRelationLayoutModel() {
        let layoutId;
        if (this.type === UIModelType.SLIDE) {
            layoutId = this.sdkData?.getLayout()?.id;
        } else if (this.type === UIModelType.LAYOUT) {
            layoutId = this.sdkData?.id;
        }
        return this.presentationRef?.layoutList
            .find(layoutModel => layoutModel?.sdkData?.id === layoutId);
    }

    getRelationMasterModel() {
        let masterId;
        if (this.type === UIModelType.SLIDE) {
            masterId = this.sdkData?.getLayout()?.getMaster()?.id;
        } else if (this.type === UIModelType.LAYOUT) {
            masterId = this.sdkData?.getMaster()?.id;
        } else if (this.type === UIModelType.MASTER) {
            masterId = this.sdkData?.id;
        }
        return this.presentationRef?.masterList
            .find(masterModel => masterModel?.sdkData?.id === masterId);
    }

    getRelationThemeModel() {
        const themeId = this.getRelationMasterModel()?.themeId;
        return this.presentationRef?.themeList.find(theme => theme?.id === themeId);
    }

    /**
     * 通过 placeholderTypeNum 查找对应的 child
     * @param plTypeNum
     * @returns
     */
    findChildByPlTypeNum(plTypeNum) {
        return this.children.find(child => child.placeHolderTypeNum === plTypeNum);
    }

    public changeLayoutLite(masterDataModel, layoutDataModel) {
        this.unBindRelationObserver(this.sdkData);
        // this.selectionService?.selectedWithCommit.markSpecialOperate(ESpecialOperationType.keep);
        (this.sdkData as SlideModelSdkTypeV3)?.api?.changeLayoutQuickSetting(
            masterDataModel,
            layoutDataModel,
        );
        this.bindRelationObserver(this.sdkData);
        // this.selectionService?.selectedElements.clear();
    }

    /**
     * 切换版式
     * @param masterIndex
     * @param layoutIndex
     */
    public changeLayout(masterIndex, layoutIndex) {
        this.unBindRelationObserver(this.sdkData);
        this.selectionService?.selectedWithCommit.markSpecialOperate(ESpecialOperationType.keep);
        const master = this.presentationRef?.masterList[masterIndex] as IMasterModel;
        const layout = master.layoutList[layoutIndex] as ILayoutModel;
        (this.sdkData as SlideModelSdkTypeV3)?.api?.changeLayout(
            master.sdkData as unknown as MasterDataModel,
            layout.sdkData as unknown as LayoutDataModel,
        );
        this.bindRelationObserver(this.sdkData);
        this.selectionService?.selectedElements.clear();
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.MASTER,
            action: TDWActionType.SWITCH_LAYOUT,
        });
    }

    public getChildrenConvertPromise(taskGroupPriority?: number): Promise<void> {
        const slideElements = this.getAllSDKShapesOnSelf(this.sdkData as ISlideDataModel);
        // window.log?.info('[ui] SlideModelChildren convert', this.sdkData?.id);
        return ConvertEngine.convertArrayDataSdkToUi(
            getElementModelConstructorByType,
            slideElements,
            this.children,
            this,
            taskGroupPriority,
        );
    }

    async convertSdkToUiChildrenLogic(rawSdkData, convertRemoveChangeset = false) {
        const convertPromises: Promise<void>[] = [];

        convertPromises.push(this.getChildrenConvertPromise());

        if (this.asyncConvertChildren) {
            await Promise.all(convertPromises);
            this.asyncConvertChildren = false;
        }

        // 等待所有子元素convert完成，设置图片异步加载
        this.setSyncLoad();

        if (!convertRemoveChangeset) {
            // 防止mobx调用栈溢出
            // https://github.com/mobxjs/mobx/issues/2214
            this.childrenConverted = true;
        }
    }

    setSyncLoad() {
        const count = 2; let k = 0;
        for (let i = 0; this.children && i < this.children.length; i++) {
            const child = this.children[i];
            if (child.type === UIModelType.IMAGE || child.type === UIModelType.SHAPE) {
                if (_get(child, 'props.style.fillBackground.image')) {
                    child.props.style.fillBackground.image.syncLoad = true;
                    k += 1;
                }
                if (child.props.src) {
                    child.props.syncLoad = true;
                    k += 1;
                }
            }
            if (k >= count) {
                break;
            }
        }
    }

    syncConvertRelationModelChildren() {
        const layout = this.sdkData?.getLayout();
        const master = layout?.getMaster();
        // @ts-ignore
        const curLayoutElements = this.getAllSDKShapesOnLayout(layout ?? null);
        // @ts-ignore
        const curMasterElements = this.getAllSDKShapesOnMaster(master ?? null);
        const masterMapValue = observable([]);
        const layoutMapValue = observable([]);
        ConvertEngine.convertArrayDataSdkToUi(
            getElementModelConstructorByType,
            curLayoutElements,
            layoutMapValue,
            this,
        );
        ConvertEngine.convertArrayDataSdkToUi(
            getElementModelConstructorByType,
            curMasterElements,
            masterMapValue,
            this,
        );
        return { masterKey: master?.id, masterMapValue, layoutKey: layout?.id, layoutMapValue };
    }

    protected deleteShapes(deleteElements): void {
        if (!this.sdkData) {
            return;
        }
        transaction(() => {
            super.deleteShapes(deleteElements);
        });
    }

    private convertChildrenTaskKey() {
        return `convert-slide-child-${this.key}-${this.id}-${this.type}`;
    }

    /**
     * 检查是否开始数据转换
     * @param priority 优先级
     * @returns boolean
     * bug单中备注视图动画不播放的问题，本质上是由于备注视图重复转换了uiModel层的数据导致的。
     * uiModel数据转换完成后，会进行canvas渲染树的创建，渲染树创建完之后会进行动画时间线的创建。
     * bug出现的原因在于动画时间线中持有的uiModel并非最后一次转换的数据。
     * 从非首页进入备注视图，备注视图会进行三次uiModel层数据转换。uiModel层数据如果已经转换成功，没必要再重复转换。
     */
    private checkContinueConvert(priority): boolean {
        const taskKey = this.convertChildrenTaskKey();
        const task = TaskManager.getTaskWithKey(taskKey);
        // slideModel层数据转换未加入任务队列中，则该页数据需要开始转换
        if (!task) return true;
        // slideModel层数据转换已加入任务队列
        if (task.isCanceled || task.isPaused) {
            // 1、任务异常执行结束（被取消或者被暂停），则该页数据需要开始转换
            return true;
        }
        if (task.priority < priority && !task.isExecuting && !task.isFinished) {
            // 2、任务未正在执行，且未执行结束（无论正常结束还是异常结束），且任务队列中的优先级低于当前优先级，
            // 则只需更新任务优先级，该页数据不需要重复转换
            task.priority = priority;
        }

        // 3、任务正在执行，则该页数据不需要重复转换
        // 4、任务正常执行结束（即未被取消，也未被暂停），则该页数据不需要重复转换
        // 5、任务未正在执行，且未执行结束（无论正常结束还是异常结束），且任务队列中的优先级不低于当前优先级，则不需要重复转换
        return false;
    }

    private async asyncConvertChildrenLogic(priority?: number): Promise<void> {
        if (this.asyncConvertChildren) {
            const sharedConvertTaskGroup = this.sharedConvertTaskgroup;
            if (sharedConvertTaskGroup && priority) {
                sharedConvertTaskGroup.priority = priority;
            }
            await this.convertSdkToUiChildrenLogic(this.sdkData);
            this.asyncConvertChildren = false;
            if (this.isSlide) {
                global.log.info('[key process]', `slide - ${this.sdkData?.id} page appear children convert end`, this.children?.length);
            }
            // 元素转换完成后，再处理动画数据转换
            await this.convertTimingDataSdkToUi?.();
            this.changeSetEngine.notifyChange();
        }
    }

    // 获取 AI 标签
    private getPageAIDescription(): {type: number} | undefined {
        const descriptionString = this.sdkData?.getOwnedData().cSld.spTree?.nvPr.descr;
        if (!descriptionString) {
            return undefined;
        }
        try {
            return {
                type: JSON.parse(descriptionString).type,
            };
        } catch {
            return undefined;
        }
    }
}

export default SlideModel;
